const state = {
  kpiDetails: [],
  kpiConfig: [],
  widgetList: [],
  // this will hold data of all widgets
  widgetData: {},
  isAddEditWidgetDialogOpen: false,
  selectedwidgetForEdit: null,
  widgetUpdateHappened: false,
  rowAdditionAllowed: false,
  selectedDashboardDate: '',
  fetchedOrgs: {}
};

const getters = {
  getWidgetData(state) {
    return state.widgetData;
  },
  getRowAdditionAllowed(state) {
    return state.rowAdditionAllowed;
  },
  getWidgetUpdateHappened(state) {
    return state.widgetUpdateHappened;
  },
  getSelectedwidgetForEdit(state) {
    return state.selectedwidgetForEdit;
  },
  toggleAddEditWidgetDialogOpen(state) {
    return state.isAddEditWidgetDialogOpen;
  },
  getKpiDetails(state) {
    return state.kpiDetails;
  },
  getWidgetList(state) {
    return state.widgetList;
  },
  getSelectedDashboardDate(state) {
    return state.selectedDashboardDate;
  },
  getFetchedOrgList(state) {
    return state.fetchedOrgs;
  },
  getCurrentOrgFetchedData(state, getters, store) {
    return state.fetchedOrgs[store.currentlySelectedOrgId];
  }
};

const mutations = {
  setWidgetData(store, widgetData) {
    store.widgetData = widgetData;
  },
  setRowAdditionAllowed(store, rowAdditionAllowed) {
    store.rowAdditionAllowed = rowAdditionAllowed;
  },
  setWidgetUpdateHappened(store, widgetUpdateHappened) {
    store.widgetUpdateHappened = widgetUpdateHappened;
  },
  setSelectedForEdit(store, selectedwidgetForEdit) {
    store.selectedwidgetForEdit = selectedwidgetForEdit;
  },
  // for add edit modal
  toggleAddEditModal(store, isOpen) {
    store.isAddEditWidgetDialogOpen = isOpen;
  },
  setKpiDetails(store, kpiDetails) {
    store.kpiDetails = kpiDetails;
  },
  setKpiConfig(store, kpiConfig) {
    store.kpiConfig = kpiConfig;
  },
  setWidgetList(store, widgetList) {
    store.widgetList = widgetList;
  },
  reset(store) {
    store.isAddEditWidgetDialogOpen = true;
  },
  setSelectedDashboardDate(store, { selectedDate }) {
    store.selectedDashboardDate = selectedDate;
  },
  addNewFetchedOrg(store, newOrgData) {
    store.fetchedOrgs = {
      ...(store.fetchedOrgs ? store.fetchedOrgs : {}),
      ...newOrgData
    };
  },
  updateFetchedOrgDate(state, { selectedDate, currentOrg }) {
    if (state.fetchedOrgs[currentOrg]) {
      state.fetchedOrgs[currentOrg].date = selectedDate;
    }
  }
};

const actions = {
  dialog({ commit }) {
    commit('reset');
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
